import React from 'react';
import PropTypes from 'prop-types';
import { InvoiceWorkqueue } from './InvoiceWorkqueue';
import { INVOICE_WQ_BULK_ACTIONS, SUBMITTED_CBO_ADMIN_STATUSES } from '../constants';
import { NoInvoicesFoundCard } from '../components';

const SubmittedInvoicesDWQ = ({ children }) => (
  <InvoiceWorkqueue
    defaultBulkActions={INVOICE_WQ_BULK_ACTIONS.default}
    cboStatuses={SUBMITTED_CBO_ADMIN_STATUSES}
    renderNoInvoicesFound={({ isFiltered, resetFilters }) => (
      <NoInvoicesFoundCard isFiltered={isFiltered} status="submitted" resetFilters={resetFilters} />
      )}
    pageName="Submitted"
    path="submitted/"
  >
    {children}
  </InvoiceWorkqueue>
  );

SubmittedInvoicesDWQ.propTypes = {
  children: PropTypes.node,
};

SubmittedInvoicesDWQ.defaultProps = {
  children: undefined,
};
export default SubmittedInvoicesDWQ;
